/** Matches Full-time or Part-time work types (case-insensitive) */
const HIGHLIGHTED_WORK_TYPES = /full.?time|part.?time/i;

/** Sorts work types: Full-time → Part-time → Gig/Contract → others */
export const getWorkTypeOrder = (name: string) => {
  const lower = name.toLowerCase();
  if (lower.includes("full")) return 0;
  if (lower.includes("part")) return 1;
  if (lower.includes("gig") || lower.includes("contract")) return 2;
  return 3;
};

export const isHighlightedWorkType = (name: string) => HIGHLIGHTED_WORK_TYPES.test(name);
